// userService.js
import {  doc, setDoc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from './config';

export const UserStatus = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

export async function createUserProfile(user) {
  try {
    const userRef = doc(db, 'users', user.email); // uid yerine email kullanımı
    await setDoc(userRef, {
      email: user.email,
      uid: user.uid, // referans için uid'yi saklıyoruz
      displayName: user.displayName || '',
      photoURL: user.photoURL || '',
      status: UserStatus.PENDING,
      createdAt: new Date().toISOString(),
      approvedAt: null,
      lastLoginAt: new Date().toISOString()
    });
  } catch (error) {
    console.error('Kullanıcı profili oluşturma hatası:', error);
    throw error;
  }
}

export async function checkUserApprovalStatus(email) {
  try {
    const userRef = doc(db, 'users', email);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      return false;
    }

    return userDoc.data().status === UserStatus.APPROVED;
  } catch (error) {
    console.error('Kullanıcı onay kontrolü hatası:', error);
    return false;
  }
}

export async function updateUserApproval(email, approved) {
  try {
    const userRef = doc(db, 'users', email);
    await updateDoc(userRef, {
      status: approved ? UserStatus.APPROVED : UserStatus.REJECTED,
      approvedAt: approved ? new Date().toISOString() : null
    });
  } catch (error) {
    console.error('Kullanıcı onay güncelleme hatası:', error);
    throw error;
  }
}